var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.5C8.29658 1.53272 9.53487 2.0455 10.475 2.939L21.475 13.939C21.876 14.3419 22.172 14.837 22.337 15.381C22.3632 15.4644 22.4312 15.5279 22.5162 15.5484C22.6012 15.5689 22.6907 15.5433 22.752 15.481L23.412 14.822C24.1921 14.0411 24.1921 12.7759 23.412 11.995L12.412 0.995C11.7531 0.385229 10.8972 0.0321654 10 0H5C4.2298 0.00108662 3.52909 0.445647 3.2 1.142C3.16332 1.21946 3.16887 1.31031 3.21471 1.38272C3.26056 1.45513 3.3403 1.49902 3.426 1.499L7 1.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.415 24C12.8837 24.002 12.3738 23.791 12 23.4131L1 12.4141C0.387508 11.7559 0.0325295 10.8984 0 10V5C0 3.89551 0.89543 3 2 3H7C7.89916 3.0332 8.75633 3.38867 9.415 4.00195L20.415 15.002C21.1951 15.7832 21.1951 17.0479 20.415 17.8291L17.829 20.415L14.829 23.415C14.4547 23.791 13.9456 24.002 13.415 24ZM7 8.5C7 7.67188 6.32843 7 5.5 7C4.67157 7 4 7.67188 4 8.5C4 9.32812 4.67157 10 5.5 10C6.32843 10 7 9.32812 7 8.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.aa73b200.svg";
export { ForwardRef as ReactComponent };